import { createSlice } from "@reduxjs/toolkit";

interface initalStateInterface{
  filter: {
    page: number,
    limit: number,
  },
  dropDown: {
    orgUnit:{id:string |number | null ,label:string|number | null},
    year:{},
    month:{}
  },
};

const initialState:initalStateInterface = {
  filter: {
    page: 1,
    limit: 10,
  },
  dropDown: {
    orgUnit:{id: 'null', label: 'All'},
    year:{},
    month:{}
  },
};

const attendanceModuleSlice = createSlice({
  name: "attendanceModule",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.filter.page = action.payload;
    },
    setLimit: (state, action) => {
      state.filter.limit = action.payload;
    },


    setYear:(state,action)=>{
        state.dropDown.year=action.payload;
        
    },

       setMonth:(state,action)=>{
        state.dropDown.month=action.payload
    },
    // optional: reset all dropdowns
    resetDropDown: (state) => {
      state.dropDown = {
        orgUnit:{id: 'null', label: 'All'},
        month:{},
        year:{}
        };
    },
    resetPagination:(state)=>{
        state.filter={
          page: 1,
          limit: 10,
        }
    }
  },
});

export const {
  setPage,
  setLimit,
setYear,
setMonth,
  resetDropDown,
  resetPagination
} = attendanceModuleSlice.actions;

export default attendanceModuleSlice.reducer;
